// src/features/localization/helpers.ts
// Pure helpers for the localization module — no React imports.

import type { Entity } from '@core/types/entity';
import type { TranslationKeyStatus, TranslationStatus } from '@core/types/localization';

export interface ScopeIds {
  platformId: string;
  productId: string;
  tenantId: string;
}

/** Build a fully-populated Entity reference from an id and the current scope. */
export function makeEntity(id: string, typeName: string, scope: ScopeIds): Entity {
  return {
    type_id: '',
    type_name: typeName,
    id,
    platform_id: scope.platformId,
    tenant_id: scope.tenantId,
    product_id: scope.productId,
  };
}

/** Extract an error message suitable for display. */
export function errMessage(e: unknown, fallback: string): string {
  if (e instanceof Error && e.message) return e.message;
  return fallback;
}

export function translationStatusBadgeVariant(status?: TranslationStatus): 'default' | 'success' | 'warning' | 'secondary' {
  switch (status) {
    case 'TRANSLATION_STATUS_APPROVED':
      return 'success';
    case 'TRANSLATION_STATUS_REVIEWED':
      return 'secondary';
    case 'TRANSLATION_STATUS_NEEDS_UPDATE':
      return 'warning';
    case 'TRANSLATION_STATUS_MACHINE_TRANSLATED':
      return 'warning';
    default:
      return 'default';
  }
}

export function keyStatusBadgeVariant(status?: TranslationKeyStatus): 'default' | 'warning' | 'secondary' {
  switch (status) {
    case 'TRANSLATION_KEY_STATUS_DEPRECATED':
      return 'warning';
    case 'TRANSLATION_KEY_STATUS_DRAFT':
      return 'secondary';
    default:
      return 'default';
  }
}
